<template>
  <div class="unitindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>单位列表</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/unitmanage/create')"
          >创建单位</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <el-col :span="9">
          <el-input
            placeholder="请输入单位名称或单位简写"
            v-model="unitname"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="userSearch"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="unitList" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <Edit
      :state="editState"
      @close="editState = false"
      :user="editUnit"
      @confirm="changeUnit"
    />
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import {
  unitList,
  deleteById,
  updateById,
  updateStatus
} from '@/api/unitmanage'
import TzTable from '@/components/tz-table/Index.vue'
import Edit from './components/Edit'
export default {
  components: {
    TzTable,
    Edit
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      editState: false,
      editUnit: {},
      unitList: [],
      columns: [
        {
          field: 'unitName',
          title: '单位名称'
        },
        {
          field: 'shortCn',
          title: '单位中文简写'
        },
        {
          field: 'shortEn',
          title: '单位英文简写'
        },
        {
          field: 'createDate',
          title: '创建日期'
        },
        {
          field: 'updateDate',
          title: '更新日期'
        },
        {
          title: '状态',
          type: 'switch',
          payload: {
            field: 'deactive',
            change: (row) => this.changeUnitState(row)
          }
        },
        {
          title: '操作',
          width: '260',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => {
                console.log('编辑', row)
                this.editUnit = JSON.parse(JSON.stringify(row))
                // 显示弹框
                this.editState = true
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                console.log('删除', row)
                this.deleteFn(row)
              }
            }
          ]
        }
      ],
      unitname: ''
    }
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.getUnitList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getUnitList()
    },
    // 列表
    getUnitList() {
      let unitparams = {
        searchName: this.unitname,
        size: this.size,
        page: this.page - 1
      }
      unitList(unitparams).then((res) => {
        console.log(res.data, '单位列表')
        if (res.code == 200) {
          let unitArr = res.data.data
          this.total = res.data.total
          this.unitList = unitArr.map((item) => {
            return {
              id: item.id,
              status: item.status,
              unitName: item.name,
              shortCn: item.chineseAbbreviations,
              shortEn: item.englishAbbreviation,
              createDate: item.createDate,
              updateDate: item.updateDate,
              deactive: item.status == '0' ? true : false
            }
          })
        }
      })
    },
    // 状态改变
    changeUnitState(infos) {
      console.log(infos)
      let updateStatusparams = {
        // ...infos,
        id: infos.id,
        name: infos.unitName,
        chineseAbbreviations: infos.shortCn,
        englishAbbreviation: infos.shortEn,
        status: infos.deactive ? 0 : 1
      }
      console.log(updateStatusparams)

      updateStatus(updateStatusparams).then((res) => {
        console.log(res.data, '更新')
        // this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getUnitList()
        } else {
          this.$message({
            type: 'error',
            message: '更新失败!'
          })
        }
      })
    },
    // 编辑
    changeUnit(infos) {
      console.log(infos)
      this.$loading({
        text: '单位信息更新中'
      })
      let updateparams = {
        ...infos,
        name: infos.unitName,
        chineseAbbreviations: infos.shortCn,
        englishAbbreviation: infos.shortEn,
        status: infos.deactive ? 0 : 1
      }
      updateById(updateparams).then((res) => {
        console.log(res.data, '更新')
        this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getUnitList()
        } else {
          this.$message({
            type: 'error',
            message: '更新失败!'
          })
        }
        this.editState = false
      })
    },
    // 删除
    deleteFn(row) {
      console.log('删除', row)

      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteById(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getUnitList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 模糊查询
    userSearch() {
      // this.page = 1
      this.getUnitList()
    }
  },
  mounted() {
    this.getUnitList()
  }
}
</script>

<style></style>
